jQuery(document).ready(function($) {
    'use strict';

    var warning = $('.startpage-notmember');


    $(document).on('click', '.startpage-notmember .icon-close', function() {
        warning.toggleClass('hidden');
        console.log('klickat');
    });
});